import { jsx as a, jsxs as r } from "react/jsx-runtime";
import { accordionBlueprint as H } from "./index-blueprint.es.js";
import * as s from "@radix-ui/react-accordion";
import { AngleDownIcon as P, AngleUpIcon as k } from "@made-people/blueprint-icons";
import { clsx as w } from "clsx";
import { withZod as B } from "@made-people/react-prop-guard";
import { withManagedProps as D } from "@made-people/managed-props";
import { headingSchema as E, Heading as O } from "@made-people/blueprint-heading";
import { componentWrapperSchema as T, ComponentWrapper as U } from "@made-people/blueprint-component-wrapper";
import { responsiveImageSchema as M, ResponsiveImage as C } from "@made-people/blueprint-responsive-image";
import { Markdown as V } from "@made-people/blueprint-markdown";
import Z from "react";
import { z as l } from "zod";
import "@made-people/blueprint";
const $ = ({
  content: e
}) => e ? typeof e == "string" ? /* @__PURE__ */ a(V, { content: e }) : Z.isValidElement(e) ? e : null : null, q = l.object({
  content: l.object({
    value: l.string().optional(),
    content: l.custom().or(l.string()).optional(),
    trigger: l.custom().optional(),
    icon: M.optional(),
    forceMount: l.boolean().optional()
  }),
  /**
   * Item settings for the accordion. Includes disabeling the item, etc.
   */
  radixAccordionItemSettings: l.object({
    header: l.custom().optional(),
    content: l.custom().optional(),
    item: l.custom().optional(),
    trigger: l.custom().optional()
  }).optional()
}), F = l.object({
  variants: l.custom().optional(),
  blueprint: l.custom().optional(),
  layout: T.shape.layout.optional(),
  /**
   * The items for the accordion including content with value, trigger and content.
   */
  items: l.array(q).optional(),
  /**
   * Accordion Heading
   */
  headerLeftImage: M.optional(),
  heading: E.optional(),
  icons: l.object({
    open: l.custom().optional(),
    close: l.custom().optional()
  }).optional(),
  /**
   * Global settings for the accordion.
   */
  radixAccordionSettings: l.object({
    root: l.union([
      l.custom(),
      l.custom()
    ]).optional(),
    header: l.custom().optional(),
    content: l.custom().optional(),
    item: l.custom().optional(),
    trigger: l.custom().optional()
  }).optional()
}), i = D(
  "Accordion",
  B(
    {
      schema: F,
      defaultProps: {
        icons: {
          open: /* @__PURE__ */ a(P, {}),
          close: /* @__PURE__ */ a(k, {})
        },
        radixAccordionSettings: {
          root: {
            type: "single",
            collapsible: !0
          }
        }
      }
    },
    ({
      items: e,
      icons: h,
      radixAccordionSettings: o,
      variants: R,
      heading: f,
      layout: W,
      headerLeftImage: v,
      blueprint: z
    }) => {
      if (!(e != null && e.length))
        return null;
      const m = (z ?? H).styles(R);
      return /* @__PURE__ */ r(U, { layout: { ...W }, className: m.base, children: [
        (f == null ? void 0 : f.heading) && /* @__PURE__ */ r("div", { className: m.headerWrapper, children: [
          v && v.image && /* @__PURE__ */ a(
            C,
            {
              ...v,
              className: m.headerLeftImage,
              displaySize: "32px"
            }
          ),
          /* @__PURE__ */ a(O, { ...f, className: m.header })
        ] }),
        /* @__PURE__ */ a(s.Root, { type: "single", ...o == null ? void 0 : o.root, children: e.map(({ content: u, radixAccordionItemSettings: p }) => {
          var N, b, y, t, j;
          return /* @__PURE__ */ r(
            s.Item,
            {
              className: w("group overflow-hidden", m.item),
              value: u.value ?? ((N = u.trigger) == null ? void 0 : N.toString()) ?? "",
              ...o == null ? void 0 : o.item,
              ...p == null ? void 0 : p.item,
              children: [
                /* @__PURE__ */ a(
                  s.Header,
                  {
                    ...o == null ? void 0 : o.header,
                    ...p == null ? void 0 : p.header,
                    asChild: !0,
                    children: /* @__PURE__ */ r(
                      s.Trigger,
                      {
                        className: m.trigger,
                        ...o == null ? void 0 : o.trigger,
                        ...p == null ? void 0 : p.trigger,
                        children: [
                          u.icon && ((y = (b = u.icon) == null ? void 0 : b.initial) == null ? void 0 : y.src) && /* @__PURE__ */ a(
                            C,
                            {
                              ...u.icon,
                              className: m.icon
                            }
                          ),
                          u.trigger,
                          (h == null ? void 0 : h.close) && /* @__PURE__ */ a("div", { className: m.iconClose, children: h.close }),
                          (h == null ? void 0 : h.open) && /* @__PURE__ */ a("div", { className: m.iconOpen, children: h.open })
                        ]
                      }
                    )
                  }
                ),
                /* @__PURE__ */ a(
                  s.Content,
                  {
                    ...o == null ? void 0 : o.content,
                    ...p == null ? void 0 : p.content,
                    ...u.forceMount && { forceMount: !0 },
                    className: w(
                      "data-[state=closed]:invisible data-[state=closed]:max-h-0 data-[state=closed]:overflow-hidden",
                      (t = o == null ? void 0 : o.content) == null ? void 0 : t.className,
                      (j = p == null ? void 0 : p.content) == null ? void 0 : j.className
                    ),
                    children: /* @__PURE__ */ a("div", { className: m.content, children: /* @__PURE__ */ a($, { content: u.content }) })
                  }
                )
              ]
            },
            `accordion-item-${u.value ?? u.trigger}`
          );
        }) })
      ] });
    }
  )
);
export {
  i as Accordion,
  $ as AccordionContent,
  q as accordionItemSchema,
  F as accordionSchema
};
//# sourceMappingURL=index.es.js.map
